// @flow
import React from 'react';
import moment from 'moment';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import Radio from 'common/domain/radio';
import ConnectorsAPI from '../../connectors/services/ConnectorsAPI';

export const CONNECTOR_LAST_SYNC_TIME_ID = 'connectors-last-sync-time';

const Wrapper = styled.div`
  color: ${({ theme }) => theme.colors.darkGray};
`;

type Props = {
  token: string,
  radio: Radio,

  t: any,
}

type State = {
  lastSyncTime: ?moment
}

export class LastSyncTime extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { lastSyncTime: null };
  }

  async componentDidMount() {
    await this.fetchLastSyncTime();
  }

  async componentDidUpdate(prevProps: Props) {
    if (!this.props.radio.isSame(prevProps.radio)) {
      this.fetchLastSyncTime();
    }
  }

  async fetchLastSyncTime() {
    const { radio, token } = this.props;

    try {
      const lastSyncTime = await ConnectorsAPI.fetchLastSyncMoment(radio, token);
      this.setState({ lastSyncTime });
    } catch (error) {
      // do nothing
    }
  }

  render() {
    const { lastSyncTime } = this.state;
    const { t } = this.props;
    if (!lastSyncTime) {
      return null;
    }

    return <Wrapper id={CONNECTOR_LAST_SYNC_TIME_ID}>{t('lastSyncTime', { time: lastSyncTime })}</Wrapper>;
  }

}

export default withTheme(translate('salesDashboard')(LastSyncTime));



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/components/LastSyncTime.js